module.exports = __webpack_public_path__ + "img/dust.a523211b.jpg";